(function (w, d) {
  if (w.__ES_THEME_RUNTIME_BOOTED && typeof w.__ES_THEME_RUNTIME_REHYDRATE === 'function') {
    try { w.__ES_THEME_RUNTIME_REHYDRATE(); } catch (e) {}
    return;
  }
  w.__ES_THEME_RUNTIME_BOOTED = true;

  var flags = w.ES_THEME_FLAGS || {};
  var revealTimer = 0;

  function onReady(fn) {
    if (d.readyState === 'loading') {
      d.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function onWindowLoad(fn) {
    if (d.readyState === 'complete') {
      fn();
    } else {
      w.addEventListener('load', fn, { once: true });
    }
  }

  function clearRevealTimer() {
    if (!revealTimer) return;
    try { clearTimeout(revealTimer); } catch (e) {}
    revealTimer = 0;
  }

  function revealFooterFallbackIfNeeded() {
    if (!flags.hasFooterFallback) return;
    try {
      var visibleFooter = d.querySelector('footer.footer_v1, footer.footer_v2, footer.footer_v3, footer.footer_v4, footer.footer_v5, footer.footer_v6, #shopify-section-footer footer');
      if (visibleFooter && (visibleFooter.offsetHeight || 0) > 10) return;
      var fallback = d.getElementById('es-footer-fallback');
      if (fallback) fallback.style.display = 'block';
    } catch (e) {}
  }

  function queueFooterReveal(delay) {
    clearRevealTimer();
    revealTimer = w.setTimeout(function () {
      revealTimer = 0;
      revealFooterFallbackIfNeeded();
    }, Math.max(0, delay | 0));
  }

  function ensureShopifyGetProduct() {
    if (!flags.needShopifyGetProduct) return;
    w.Shopify = w.Shopify || {};
    if (typeof w.Shopify.getProduct === 'function') return;
    w.Shopify.getProduct = function (handle, cb) {
      try {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', '/products/' + encodeURIComponent(handle) + '.js', true);
        xhr.onreadystatechange = function () {
          if (xhr.readyState !== 4) return;
          if (xhr.status >= 200 && xhr.status < 300) {
            try { if (cb) cb(JSON.parse(xhr.responseText)); } catch (e) {}
          }
        };
        xhr.send(null);
      } catch (e) {}
    };
  }

  function bootResetPassword() {
    if (!flags.resetPassword) return;
    var tries = 0;
    (function tick() {
      if (w.timber && typeof w.timber.resetPasswordSuccess === 'function') {
        try { w.timber.resetPasswordSuccess(); } catch (e) {}
        return;
      }
      tries += 1;
      if (tries < 40) w.setTimeout(tick, 50);
    })();
  }

  function bootSwatchBridge($) {
    if (!flags.hasSwatches || !$ || !$.fn) return;
    $(d)
      .off('change.esThemeSwatchBridge', '.swatch :radio')
      .on('change.esThemeSwatchBridge', '.swatch :radio', function () {
        try {
          var $radio = $(this);
          var optionIndex = $radio.closest('.swatch').attr('data-option-index');
          var optionValue = $radio.val();
          $radio
            .closest('form')
            .find('.single-option-selector')
            .eq(optionIndex)
            .val(optionValue)
            .trigger('change');
        } catch (e) {}
      });
  }

  function bootSlickShim($) {
    if (!flags.needSlickShim || !$ || !$.fn || $.fn.slick) return;
    $.fn.slick = function () { return this; };
  }

  function parseBoolAttr(value) {
    return String(value).toLowerCase() === 'true' || value === '1';
  }

  function initHeaderStickyFromDom() {
    var el = d.querySelector('[data-es-header-sticky="1"]');
    if (!el || typeof initHeaderSticky !== 'function') return null;
    return initHeaderSticky({
      mode: el.getAttribute('data-es-header-sticky-mode') || 'default',
      enabled: parseBoolAttr(el.getAttribute('data-es-header-sticky-enabled')),
      transparent: parseBoolAttr(el.getAttribute('data-es-header-sticky-transparent')),
      bg: el.getAttribute('data-es-header-sticky-bg') || '',
      navSelector: '.jsheader_sticky',
      headerSelector: '.header-v1-h1'
    });
  }

  function initHeaderSticky(config) {
    var cfg = config || {};
    var prev = w.__esHeaderStickyV1;
    if (prev && typeof prev.cleanup === 'function') {
      try { prev.cleanup(); } catch (e) {}
    }

    var navSelector = cfg.navSelector || '.jsheader_sticky';
    var headerSelector = cfg.headerSelector || '.header-v1-h1';
    var nav = d.querySelector(navSelector);
    if (!nav) {
      w.__esHeaderStickyV1 = null;
      return null;
    }

    var headers = d.querySelectorAll(headerSelector);
    var enabled = !!cfg.enabled;
    var transparent = !!cfg.transparent;
    var bg = cfg.bg || '';
    var rafId = 0;
    var timeoutId = 0;
    var spacer = null;
    var naturalHeight = Math.ceil(nav.getBoundingClientRect().height || nav.offsetHeight || 0);
    var stickyThreshold = typeof cfg.threshold === 'number' ? cfg.threshold : (transparent ? 16 : 12);

    function ensureSpacer() {
      if (transparent || !nav || !nav.parentNode) return null;
      if (spacer && spacer.parentNode) return spacer;
      spacer = d.createElement('div');
      spacer.className = 'es-header-sticky-spacer';
      spacer.setAttribute('aria-hidden', 'true');
      spacer.style.display = 'none';
      spacer.style.height = '0px';
      if (nav.nextSibling) nav.parentNode.insertBefore(spacer, nav.nextSibling);
      else nav.parentNode.appendChild(spacer);
      return spacer;
    }

    function updateNaturalHeight() {
      if (!nav) return naturalHeight;
      if (!nav.classList.contains('menu_scroll_v1')) {
        naturalHeight = Math.ceil(nav.getBoundingClientRect().height || nav.offsetHeight || naturalHeight || 0);
      }
      return naturalHeight;
    }

    function syncSpacer(isActive) {
      if (transparent) return;
      var node = ensureSpacer();
      if (!node) return;
      if (!isActive) {
        node.style.height = '0px';
        node.style.display = 'none';
        return;
      }
      var h = updateNaturalHeight() || Math.ceil(nav.offsetHeight || 0);
      if (!h) h = Math.ceil(nav.getBoundingClientRect().height || 0);
      node.style.display = 'block';
      node.style.height = h + 'px';
    }

    function applyBaseBackground() {
      if (transparent) return;
      if (!bg) return;
      try {
        headers.forEach(function(el){ el.style.background = bg; });
      } catch (e) {}
    }

    function syncHeader() {
      rafId = 0;
      timeoutId = 0;
      if (!nav) return;

      var top = w.pageYOffset || d.documentElement.scrollTop || 0;
      var passed = top > stickyThreshold;

      if (!passed) updateNaturalHeight();

      try {
        nav.classList.toggle('menu_scroll_v1', passed);
        headers.forEach(function(el){
          el.classList.toggle('menu_scroll_v1', passed);
          el.classList.toggle('es-header-sticky-compact', passed);
        });
        d.documentElement.classList.toggle('es-header-sticky-active', passed);
      } catch (e) {}

      syncSpacer(passed);

      if (passed) {
        if (bg) {
          try {
            headers.forEach(function(el){ el.style.background = bg; });
          } catch (e) {}
        }
      } else if (transparent) {
        try {
          headers.forEach(function(el){ el.style.background = 'none'; });
        } catch (e) {}
      }
    }

    function scheduleSync() {
      if (rafId || timeoutId) return;
      if (typeof w.requestAnimationFrame === 'function') {
        rafId = w.requestAnimationFrame(syncHeader);
      } else {
        timeoutId = w.setTimeout(syncHeader, 16);
      }
    }

    function onPageShow() {
      applyBaseBackground();
      scheduleSync();
    }

    function onPageHide() {
      if (rafId && typeof w.cancelAnimationFrame === 'function') {
        try { w.cancelAnimationFrame(rafId); } catch (e) {}
      }
      if (timeoutId) {
        try { clearTimeout(timeoutId); } catch (e) {}
      }
      rafId = 0;
      timeoutId = 0;
    }

    function cleanup() {
      onPageHide();
      try { w.removeEventListener('scroll', scheduleSync); } catch (e) {}
      try { w.removeEventListener('resize', scheduleSync); } catch (e) {}
      try { w.removeEventListener('pageshow', onPageShow); } catch (e) {}
      try { w.removeEventListener('pagehide', onPageHide); } catch (e) {}
      try { d.documentElement.classList.remove('es-header-sticky-active'); } catch (e) {}
      try {
        headers.forEach(function(el){ el.classList.remove('es-header-sticky-compact'); });
      } catch (e) {}
      syncSpacer(false);
    }

    applyBaseBackground();
    ensureSpacer();

    if (enabled) {
      scheduleSync();
      w.addEventListener('scroll', scheduleSync, { passive: true });
      w.addEventListener('resize', scheduleSync);
      w.addEventListener('pageshow', onPageShow);
      w.addEventListener('pagehide', onPageHide);
    } else {
      syncSpacer(false);
    }

    w.__esHeaderStickyV1 = {
      cleanup: cleanup,
      mode: cfg.mode || 'default',
      sync: scheduleSync
    };
    return w.__esHeaderStickyV1;
  }


  function syncFixedHeaderHeights() {
    var root = d.documentElement;
    if (!root) return;

    function setVar(selector, varName, fallback) {
      var el = d.querySelector(selector);
      var h = el ? Math.ceil(el.getBoundingClientRect().height || el.offsetHeight || 0) : 0;
      root.style.setProperty(varName, (h || fallback) + 'px');
    }

    setVar('.es-header-fixed', '--es-header-height', 76);
    setVar('.es-mobile-header-fixed', '--es-mobile-header-height', 60);
  }

  w.__ES_THEME_INIT_HEADER_STICKY = initHeaderSticky;

  function bootThirdPartyOverlayUnifier() {}


  function rehydrate() {
    revealFooterFallbackIfNeeded();
    queueFooterReveal(60);
    initHeaderStickyFromDom();
  }

  onReady(function () {
    revealFooterFallbackIfNeeded();
    initHeaderStickyFromDom();
  });
  onWindowLoad(function () {
    revealFooterFallbackIfNeeded();
    queueFooterReveal(60);
  });
  w.addEventListener('pageshow', rehydrate);
  w.addEventListener('pagehide', clearRevealTimer);
  ensureShopifyGetProduct();
  // Third-party overlays (Judge.me / Wishlist / MUI, etc.) are intentionally left to their native styles.
  // Earlier runtime unification caused late visual swaps (e.g. Judge.me overlay changing after open).
  // Keep first-party modals/drawers unified via CSS, but do not mutate third-party overlays at runtime.

  if (typeof w.ES_jqReady === 'function') {
    w.ES_jqReady(function ($) {
      bootResetPassword();
      bootSwatchBridge($);
      bootSlickShim($);
    });
  } else {
    onReady(function () {
      if (w.jQuery) {
        bootResetPassword();
        bootSwatchBridge(w.jQuery);
        bootSlickShim(w.jQuery);
      }
    });
  }

  w.__ES_THEME_RUNTIME_REHYDRATE = rehydrate;
})(window, document);

;(function(w,d){
  if (w.__ES_LIVE_CTA_SPINNER_BOOTED) return;
  w.__ES_LIVE_CTA_SPINNER_BOOTED = true;

  var activeSelector = [
    'form[action^="/cart/add"] .es-cart-submit-pending',
    'form[action^="/cart/add"] .es-cart-submit-lock',
    'form[action^="/cart/add"] [aria-busy="true"]',
    '[data-es-lensbuilder-launch][aria-busy="true"]',
    '.es-pdp-primary-cta[aria-busy="true"]',
    '.es-pdp-primary-cta.es-cart-submit-pending',
    '.es-pdp-primary-cta.es-cart-submit-lock',
    '.btn-addToCart[aria-busy="true"]',
    '.btn-addToCart.is-loading',
    '.es-qv-select-lenses[aria-busy="true"]',
    '.es-qv-select-lenses.is-loading'
  ].join(',');

  var candidateSelector = [
    'form[action^="/cart/add"] button',
    'form[action^="/cart/add"] [type="submit"]',
    '[data-es-lensbuilder-launch]',
    '.es-pdp-primary-cta',
    '.btn-addToCart',
    '.es-qv-select-lenses'
  ].join(',');

  function makeSpinner(){
    var span = d.createElement('span');
    span.className = 'es-live-cta-spinner';
    span.setAttribute('aria-hidden', 'true');
    return span;
  }

  function isActive(el){
    if (!el || !el.matches) return false;
    try { return el.matches(activeSelector); } catch(e) { return false; }
  }

  function ensure(el){
    if (!el || !el.querySelector) return;
    var spinner = el.querySelector(':scope > .es-live-cta-spinner');
    try {
      var spinners = el.querySelectorAll(':scope > .es-live-cta-spinner');
      if (spinners && spinners.length > 1) {
        for (var i = 1; i < spinners.length; i += 1) {
          if (spinners[i] && spinners[i].parentNode) spinners[i].parentNode.removeChild(spinners[i]);
        }
        spinner = spinners[0] || spinner;
      }
    } catch(eDup) {}
    if (isActive(el)) {
      if (!spinner) el.appendChild(makeSpinner());
      try { el.setAttribute('data-es-live-spinner', '1'); } catch(e) {}
    } else {
      if (spinner) spinner.parentNode.removeChild(spinner);
      try { el.removeAttribute('data-es-live-spinner'); } catch(e) {}
    }
  }

  function sync(root){
    root = root && root.querySelectorAll ? root : d;
    try {
      if (root.matches && root.matches(candidateSelector)) ensure(root);
    } catch(e0) {}
    try {
      root.querySelectorAll(candidateSelector).forEach(ensure);
    } catch(e1) {}
  }

  var scheduled = 0;
  function schedule(root){
    if (scheduled) return;
    scheduled = w.setTimeout(function(){
      scheduled = 0;
      sync(root || d);
    }, 0);
  }

  function boot(){
    sync(d);
    try {
      new MutationObserver(function(muts){
        for (var i = 0; i < muts.length; i += 1) {
          var m = muts[i];
          if (m.type === 'attributes') {
            var t = m.target;
            if (t && t.matches && t.matches(candidateSelector)) ensure(t);
          } else if (m.type === 'childList') {
            schedule(d);
          }
        }
      }).observe(d.documentElement, { subtree:true, childList:true, attributes:true, attributeFilter:['class','aria-busy','disabled','aria-disabled'] });
    } catch(e) {}
  }

  d.addEventListener('click', function(){ schedule(d); }, true);
  d.addEventListener('submit', function(){ schedule(d); }, true);
  w.__ES_CTA_SPINNER_SYNC = function(){ sync(d); };

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot, { once:true });
  else boot();
})(window, document);
